<script lang="ts" setup>
import { ref, defineEmits, defineProps, computed } from "vue";

import AppCheckbox from "@/components/atoms/input/AppCheckbox.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import { authStore } from "@/store/auth";

const props = defineProps({
  workerLastName: {
    type: String,
    required: true
  }
});
const isChecked = ref(false);
const emit = defineEmits(["back", "confirm"]);

const applicationNotesImage = computed(() =>
  require("@/assets/img/applicationReminder/ApplicationNotes" +
    authStore.productAssetSuffix +
    ".png")
);

const onSubmit = () => {
  emit("confirm");
};

const onBack = () => {
  emit("back");
};
</script>

<template>
  <div class="container">
    <img :src="applicationNotesImage" alt="キャンセル方法" class="image" />
    <p data-testid="greeting-message">
      現場の職員・ご利用者様・患者様が{{
        props.workerLastName
      }}さんのことを待っています✨よろしくお願いします❗
    </p>
    <AppCheckbox text="確認しました" class="checkbox" v-model="isChecked" />
    <AppButton
      variant="primary"
      class="w-100"
      :disabled="!isChecked"
      @click="onSubmit"
      >勤務確定</AppButton
    >
    <AppButtonOutline @click="onBack" variant="primary" class="w-100"
      >戻る</AppButtonOutline
    >
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  padding: 0;
}

.image {
  width: 100%;
}

.checkbox {
  :deep(span) {
    font-size: 16px !important;
  }
}

.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  width: 100%;
}
</style>
